// extracted by mini-css-extract-plugin
export default {"fauxWhite":"styles_fauxWhite__imSkr","white":"styles_white__tXrIQ"};